import FetchIt from "./FetchIt"

const get_repayment = new FetchIt('/case/get-repayment')
const track_repayment = new FetchIt('/case/track-repayment/')

 const Repayment = {
    getMany: ({ params }) => get_repayment.get({ params }),
    putById: ({ id, payload, case_id }) => track_repayment.put({ url: track_repayment.url + case_id + '/', body: { ...payload, id } })
}

export default Repayment